import { render, staticRenderFns } from "./CollectionHeader.vue?vue&type=template&id=3622c5fa"
import script from "./CollectionHeader.vue?vue&type=script&lang=js"
export * from "./CollectionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports